import { useLocation } from 'react-router'

import { EntityImage } from '@tribeplatform/react-components/common/components'
import { useRouter } from '@tribeplatform/react-sdk'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

import { BC } from '../../types/index.js'
import { LinkMenuProps } from './types.js'

export const LinkMenuBlock: BC<LinkMenuProps> = ({ items, title, ...rest }) => {
  const { Link } = useRouter()
  const location = useLocation()
  if (!items) {
    return null
  }

  return (
    <NavVertical {...rest}>
      <NavVertical.Group>
        {!!title && <NavVertical.GroupHeader>{title}</NavVertical.GroupHeader>}
        {items.map(item => {
          let isActive = false
          if (item?.href) {
            if (item.href === '/') {
              isActive = location?.pathname === item.href
            } else {
              isActive = location?.pathname?.indexOf(item?.href) === 0
            }
          }
          return (
            <NavVertical.Item
              key={item?.text}
              variant="inherit"
              as={Link}
              href={item?.href}
              target={item?.openInNewWindow ? '_blank' : null}
              active={isActive}
              leadingIcon={
                <div className="-ms-1 me-3 w-6 h-6 flex-shrink-0 flex items-center justify-center">
                  <EntityImage
                    size="xs"
                    entity={{ image: item?.image, name: item?.text }}
                  />
                </div>
              }
            >
              {item?.text}
            </NavVertical.Item>
          )
        })}
      </NavVertical.Group>
    </NavVertical>
  )
}
